import { useContext } from 'react';
import Button from '../../../components/Button';
import themeContext from '../../../context/theme/themeContext';
import Cover from '../../../layout/Cover';
import EmissionRewards from './Rewards/EmissionRewards';
import RewardActions from './Rewards/RewardActions';
import VoSpoolEpoch from './Rewards/VoSpoolEpoch';
import Stake from './StakeActions/Stake';
import Unstake from './StakeActions/Unstake';
import AccumulatedVoSpool from './Voting/AccumulatedVoSpool';
import VoSpoolEpochRewards from './Rewards/VoSpoolEpochRewards';
import StakedByCommunity from './Community/StakedByCommunity';
import VoSpoolAccumulatedByCommunity from './Community/VoSpoolAccumulatedByCommunity';
import CommunityPerformanceFeesToDate from './Community/CommunityPerformanceFeesToDate';
import CommunityRealizedPerformanceFeesToDate from './Community/CommunityRealizedPerformanceFeesToDate';
import CommunityUnrealizedPerformanceFeesToDate from './Community/CommunityUnrealizedPerformanceFeesToDate';

const Staking: React.FC = () => {
    const { theme } = useContext(themeContext);

    return (
        <div className={`vault-tab staking ${theme}`}>
            <Cover useMinHeight={true}>
                <div className='inner__left'>
                    <h2>Staking</h2>
                </div>
                <div className='inner__right'>
                    <Stake />
                    <Unstake />
                </div>
                {/* <div className='inner__left'>
                    <h2>Performance Fees</h2>
                </div>
                <div className='inner__right'>
                    <PerformanceFeesActions />
                    <PerformanceFeesInfo />
                </div> */}
                <div className='inner__left'>
                    <h2>Rewards</h2>
                </div>
                <div className='inner__right'>
                    {/* SPOOL Staking DAO Rewards */}
                    <RewardActions />
                    <EmissionRewards />
                    <VoSpoolEpoch />
                    <VoSpoolEpochRewards />
                </div>
                <div className='inner__left'>
                    <h2>Voting</h2>
                </div>
                <div className='inner__right'>
                    <AccumulatedVoSpool />
                    <Button variant='secondary' disabled>
                        Vote
                    </Button>
                </div>
                <div className='inner__left'>
                    <h2>Community</h2>
                </div>
                <div className='inner__right community'>
                    <StakedByCommunity />
                    <VoSpoolAccumulatedByCommunity />
                    <CommunityPerformanceFeesToDate />
                    <CommunityRealizedPerformanceFeesToDate />
                    <div />
                    <CommunityUnrealizedPerformanceFeesToDate />
                </div>
            </Cover>
        </div>
    );
};

export default Staking;
